export default theme => ({
  root: {
    height: 42,
    background: theme.palette.grey.eccoGrey,
    color: theme.palette.common.white,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '1.1553rem',
    fontWeight: theme.typography.fontWeightLight,
    paddingTop: theme.spacing(["3", 1]),
    [theme.breakpoints.down("sm")]: {
      height: 42,
      fontSize: '1.1553rem',
      width: "auto"
    },
    [theme.breakpoints.down("md")]: {
      height: 42,
      fontSize: '0.9000rem',
      width: "auto"
    },
  },

  mostrarTextM: {
    [theme.breakpoints.up("md")]: {
      display: "none"
    }
  },

  mostrarTextT: {
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },


});